import { CategoryData } from '../../../../types/types';

export const salutations: CategoryData = {

  'On jaraama': { translation: 'Bonjour', translationEn: 'Hello', audio: 'Ff-On_jaraama' },
  'Tanaa ala ton': { translation: 'Est-ce que tout le monde va bien', translationEn: 'Is everyone doing well?', audio: 'Ff-Tanaa_ala_ton' },
  'No wadou ndaa': { translation: 'Comment vas-tu ?', translationEn: 'How are you?', audio: 'Ff-No_wadou_ndaa' },
  'Hi ndaa e diam': { translation: 'Comment vas-tu ?', translationEn: 'How are you?', audio: 'Ff-Hi_ndaa_e_diam' },
  'Dian toun': { translation: 'La paix seulement', translationEn: 'Peace only', audio: 'Ff-Dian_toun' },
  'Miɗo e jam': { translation: 'Je vais bien', translationEn: 'I am fine', audio: 'Ff-Mido_e_jam' },
  'A jaraama (merci)': { translation: 'Merci', translationEn: 'Thank you', audio: 'Ff-A_jaaraama' },
  'Hino mo e diam ?': { translation: 'Comment va-t-il ?', translationEn: 'How is he doing?', audio: 'Ff-Hino_mo_e_diam' },
  'Hino bhe e diam': { translation: 'Ils vont bien', translationEn: 'They are doing well', audio: 'Ff-Hino_bhe_e_diam' },
  'Hon to wondaa yaa dhe': { translation: 'Où vas tu ?', translationEn: 'Where are you going?', audio: 'Ff-Hon_to_wondaa_yaa_dhe' },
  'Haa_honto': { translation: 'Où vas tu ?', translationEn: 'Where are you going?', audio: 'Ff-Haa_honto' },
  'Lan_yaa_dhe_ka_soudou': { translation: 'Je vais a la maison', translationEn: 'I am going home', audio: 'Ff-Lan_yaa_dhe_ka_soudou' },
  'Jam weeti ?': { translation: 'Avez-vous bien dormi?', translationEn: 'Did you sleep well?', audio: 'Ff-Jam_weeti' },
  'No_mbadda_e_golle ?': { translation: 'Comment se passe le travail ?', translationEn: 'How is work going?', audio: 'Ff-No_mbadda_e_golle' },
  'No yimbe galle mon mbadi ?': { translation: 'Comment va la famille ?', translationEn: 'How is the family?', audio: 'Ff-No_yimbe_galle_mon_mbadi' },
  'Waluu e jam': { translation: 'Bonne nuit', translationEn: 'Good night', audio: 'Ff-Waluu_e_jam' },
  'Landal': { translation: 'Une question', translationEn: 'A question', audio: 'Ff-Landal' },

};

export default salutations;

export {};
